import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { BottomSheet } from "@componentsShared/BottomSheet";
import useWebView from "@hooks/useWebview";
import { Icon } from "@syarahtech/ui";
var CheckSmallIcon = function CheckSmallIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    className: "shrink-0",
    style: {
      width: 20,
      height: 20
    },
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6 9 17l-5-5"
  }));
};
var DownloadIcon = function DownloadIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    className: "w-6 h-6",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.58a1 1 0 0 1-.71-.29l-3.5-3.5a1 1 0 0 1 1.42-1.42L11 12.16V5a1 1 0 0 1 2 0v7.16l1.79-1.79a1 1 0 1 1 1.42 1.42l-3.5 3.5a1 1 0 0 1-.71.29ZM6 19a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2H6Z"
  }));
};
var CouponQrModal = function CouponQrModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    coupon = _ref.coupon,
    pdfDownloadUrl = _ref.pdfDownloadUrl,
    tShort = _ref.tShort;
  var _useState = useState(false),
    copied = _useState[0],
    setCopied = _useState[1];
  var webview = useWebView();
  var handleDownload = function handleDownload(e) {
    e.preventDefault();
    if (!pdfDownloadUrl) return;
    webview.openFile(pdfDownloadUrl)["catch"](function () {
      document.location = "/download?url=".concat(encodeURIComponent(pdfDownloadUrl));
    });
  };
  var handleCopy = function handleCopy() {
    var _navigator$clipboard;
    if (!__IS_CSR__) return;
    (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(coupon.coupon_id).then(function () {
      return setCopied(true);
    })["catch"](function () {});
  };
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: open,
    onOpen: function onOpen() {},
    onClose: onClose,
    haveClose: true,
    hideTitleBar: true,
    modalDesign: {
      closeAnimation: false
    },
    maxWidthDesktop: "900px",
    customClassName: "oil-modal",
    maxHeight: "90%",
    screens: [{
      component: /*#__PURE__*/React.createElement("div", {
        className: "flex justify-center px-6 pb-6",
        dir: "rtl"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-full max-w-[360px] md:max-w-[500px] flex flex-col items-center gap-[30px]"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-2 items-center text-center text-[#00143c] max-w-[288px] md:max-w-[500px]"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "text-2xl font-bold leading-10"
      }, tShort("qr/scan_title", {
        ns: "web_tracking"
      })), /*#__PURE__*/React.createElement("p", {
        className: "text-sm md:text-xl font-semibold leading-6"
      }, tShort("qr/scan_subtitle", {
        ns: "web_tracking"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-[30px] items-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col gap-2 items-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "size-[196px] lg:size-[200px] rounded-[12px] bg-[#f1f6fc] border border-[#e6e9ef] flex items-center justify-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-white rounded-[7px] p-2.5"
      }, /*#__PURE__*/React.createElement("img", {
        src: coupon.qr_code_url,
        alt: coupon.coupon_id,
        className: "w-[134px] h-[134px] lg:w-[150px] lg:h-[150px] object-contain"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2 items-center justify-self-start py-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "relative shrink-0"
      }, copied && /*#__PURE__*/React.createElement("span", {
        className: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 bg-[#020202] text-[#96e0bf] text-[10px] leading-4 rounded px-2 py-0.5 whitespace-nowrap"
      }, tShort("qr/copied", {
        ns: "web_tracking"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: handleCopy,
        "aria-label": "copy",
        className: "px-0 flex items-center justify-center  ".concat(copied ? "bg-[#00b362] text-white border-0" : "bg-white border border-solid border-[#e6e9ef] text-[#6b7ea5]")
      }, copied ? /*#__PURE__*/React.createElement(CheckSmallIcon, null) : /*#__PURE__*/React.createElement(Icon, {
        width: 5,
        height: 5,
        className: "text-primary-new",
        icon: "material-symbols--content-copy-outline-rounded"
      }))), /*#__PURE__*/React.createElement("span", {
        className: "text-xs font-bold leading-4 text-[#6b7ea5] tracking-[-0.3px] truncate max-w-[240px]"
      }, coupon.coupon_id))), /*#__PURE__*/React.createElement("div", {
        className: "inline-flex gap-1 items-center bg-[#fbfbfb] border border-solid border-[#e6e9ef] rounded-[13px] px-3 py-1.5 text-xs leading-4 text-[#020202]"
      }, /*#__PURE__*/React.createElement("span", {
        className: "flex gap-1 items-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-normal"
      }, tShort("qr/valid_until", {
        ns: "web_tracking"
      })), /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, coupon.expiry_date)), /*#__PURE__*/React.createElement("span", {
        className: "size-3 rounded-full bg-[#00b362] shrink-0"
      }))), /*#__PURE__*/React.createElement("a", {
        href: pdfDownloadUrl,
        onClick: handleDownload,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "md:w-[318px] md:mx-auto w-full hover:text-white flex gap-2 items-center justify-center bg-[#0d0db5] text-white rounded px-4 py-3 text-base font-bold leading-6"
      }, tShort("qr/download", {
        ns: "web_tracking"
      }), /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--download",
        className: "text-white",
        height: 6,
        width: 6
      }))))
    }]
  });
};
export default CouponQrModal;